import React, { useContext, useEffect, useState } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { useParams } from 'react-router-dom';
// import languageData from '../../public/json/translations.json';
// import projectsData from '../../public/json/projects.json';

import { loadJson } from '../utils/loadJson'; 

function ProjectDetail() {
    const { id } = useParams();
    const [project, setProject] = useState(null);
    const { language } = useContext(LanguageContext);
    const [translations, setTranslations] = useState({});
    // const [projects, setProjects] = useState({});


    useEffect(() => {
        const fetchData = async () => {
            try {
                // Cargar los datos de traducciones
                const translationsData = await loadJson(`${process.env.PUBLIC_URL}/json/translations.json`);
                setTranslations(translationsData);

                // Cargar los datos de proyectos
                const projectsData = await loadJson(`${process.env.PUBLIC_URL}/json/projects.json`);
                // setProjects(projectsData);

                // Buscar el proyecto por ID
                const selectedProject = projectsData.find((p) => p.id === parseInt(id));
                setProject(selectedProject);
            } catch (error) {
                console.error('Error loading data:', error);
            }
        };

        fetchData();

    }, [id]);

    if (!project) {
        return <div>Project not found</div>;
    }

    const t = translations[language] || {};
    return (
        <div className="wrapper">

            <div className="card_project_detail">
                <h1>{project[language].title}</h1>

                {project[language].detailDescription.map((text, index) => (
                    <p key={index}>{text}</p>
                ))}

                <div className="media-gallery">
                    {project.media.map((item, index) => (
                        item.type === 'image' ? (
                            <img width={item.width} key={index} src={item.url} alt={`ImageSrc ${index + 1}`} />
                        ) : item.type === 'youtube' ? (

                            <iframe key={index} width={item.width} height={item.height || null} src={item.url} title={`YouTube video ${index + 1}`} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        ) : (
                            <video key={index} controls>
                                <source src={item.url} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        )
                    ))}
                </div>

                <p><h2>{t.projectsDetails.projectDownload}:</h2></p>
                <ul>
                    {project.linksAndDownloads.map((item, index) => (
                        <li key={index}>                            
                            <a href={item.url} className="details-link">{item.text}</a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default ProjectDetail;